import React, { createContext, useContext, useState, useEffect } from 'react';
import enTranslations from '../locales/en.json';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('berymo_lang') || 'en';
  });

  const [t, setT] = useState(enTranslations);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (language === 'en') {
      setT(enTranslations);
      return;
    }
    setLoading(true);
    import(`../locales/${language}.json`)
      .then(module => {
        setT(module.default);
        setLoading(false);
      })
      .catch(() => {
        // fallback to English if locale file missing
        setT(enTranslations);
        setLoading(false);
      });
  }, [language]);

  const setLang = (code) => {
    localStorage.setItem('berymo_lang', code);
    setLanguage(code);
  };

  // kept for backwards compat
  const toggleLanguage = () => setLang(language === 'en' ? 'es' : 'en');

  return (
    <LanguageContext.Provider value={{ language, setLang, toggleLanguage, t, loading }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
